import { Route, Routes } from "react-router-dom";

import Blacklist from "./Blacklist";
import Campaign from "./Campaign/Campaign";
import CampaignsList from "./CampaignsList";
import Labels from "./Labels";

export default function Campaigns() {
  return (
    <Routes>
      <Route path="/" element={<CampaignsList />} />
      <Route path="/labels" element={<Labels />} />
      <Route
        path="/blacklist"
        element={<Blacklist blacklistType="accounts" />}
      />
      <Route
        path="/blacklist/companies"
        element={<Blacklist blacklistType="companies" />}
      />
      <Route path="/:campaignId/*" element={<Campaign />} />
    </Routes>
  );
}
